export const API_URL: string = "https://wonderful-barbershop.firebaseio.com";
// export const API_URL: string =
//   "https://barbershop-test-4ccd4-default-rtdb.europe-west1.firebasedatabase.app";

export const API_KEY: string = "AIzaSyAZYSmEmiL5O1Q4nJ_gtI3Zfb4aPxoEskA";
// export const API_KEY: string = "AIzaSyDOHRMZuI72WADsJjPj9hDcYBYl9sC2vBU";
